'use client';

import { useMemo, useRef } from 'react';
import { RecoverExpertiseServer } from './server';
import type { RecoverExpertiseRootProps } from './type';
import { useVerticalScrollCarousel } from '@/hooks/useVerticalScrollCarousel';
import { useIsMobile } from '@/hooks/useIsMobile';

function buildStepWeights(itemsLength: number): number[] {
  if (!itemsLength) return [];
  return [...Array(itemsLength - 1).fill(4)];
}

export function RecoverExpertiseClient({
  children,
  title = '',
  underline = '',
  compensations = [],
  initialHeight,
  cards,
}: RecoverExpertiseRootProps & { initialHeight: number }) {
  const isMobile = useIsMobile();
  const containerRef = useRef<HTMLDivElement>(null);
  const stickyRef = useRef<HTMLDivElement>(null);
  const stepWeights = useMemo(() => buildStepWeights(cards.length), [cards.length]);

  const { activeIndex, progress, totalHeight } = useVerticalScrollCarousel(
    containerRef,
    stickyRef,
    initialHeight,
    cards.length,
    stepWeights
  );

  const cardProgress = activeIndex + progress / 100;

  return (
    <RecoverExpertiseServer
      containerRef={containerRef}
      stickyContainerRef={stickyRef}
      title={title}
      underline={underline}
      compensations={compensations}
      cards={cards}
      totalHeight={totalHeight}
      activeIndex={activeIndex}
      progress={cardProgress}
      isMobile={isMobile}
    >
      {children}
    </RecoverExpertiseServer>
  );
}

export default RecoverExpertiseClient;
